import axios from "axios";

export const parsePath = (uriPath: string, pathParams: any) => {
  const params = Object.keys(pathParams);
  params.forEach((p) => {
    uriPath = uriPath?.replace(`{${p}}`, pathParams[p]);
  });
  return uriPath;
};

export const uploadFile = async (presignedUrl: string, file: File) => {
  const result = await axios
    .put(presignedUrl, file)
    .catch((error) =>
      console.error(error.response.data, { request: error.request })
    );

  return result?.data;
};

/**
 * Recursively removes all __typename fields from an object or array.
 * @param obj The object or array to clean.
 * @returns A new object or array without any __typename fields.
 */
export function removeTypename<T>(obj: T): T {
  if (Array.isArray(obj)) {
    return obj.map(removeTypename) as unknown as T;
  } else if (obj && typeof obj === "object") {
    const newObj: any = {};
    for (const key in obj) {
      if (key !== "__typename" && Object.prototype.hasOwnProperty.call(obj, key)) {
        newObj[key] = removeTypename((obj as any)[key]);
      }
    }
    return newObj;
  }
  return obj;
}
